// View component for creating columns with cluster data
import React, { useContext } from "react";
// Components
import DashColumn from "./DashColumn";
import HiPlotSelectionModal from "../modals/HiPlotSelectionModal";
import ColumnAlert from "../modals/ColumnAlert";
//Context
import GaugeContext from "../../context/gauge/gaugeContext";
import AlertContext from "../../context/alerts/alertContext";
// UI
import Row from "react-bootstrap/Row";

const GraphGrid = () => {
	const gaugeContext = useContext(GaugeContext);
	const alertContext = useContext(AlertContext);
	const { nodesInUse, currentNode } = gaugeContext;
	const [columnAlert, setColumnAlert] = React.useState(false);

	const handleCloseToast = (event, reason) => {
		if (reason === "clickaway") {
			return;
		}
		setColumnAlert(false);
	};

	React.useEffect(() => {
		if (alertContext.alert) {
			setColumnAlert(true);
		}
	}, [alertContext.alert, nodesInUse]);

	return (
		<>
			{columnAlert && (
				<ColumnAlert
					open={columnAlert}
					handleClose={handleCloseToast}
				/>
			)}
			<Row className="graph-grid">
				{currentNode && (
					<HiPlotSelectionModal
						index={currentNode.index}
						key={currentNode.index}
					/>
				)}

				{nodesInUse.map((node, i) => (
					<DashColumn key={node.index} node={node} />
				))}
			</Row>
		</>
	);
};

export default GraphGrid;
